import { useEffect, useMemo, useState } from "react";
import { useReleaseNotes } from "../hooks/useReleaseNotes";
import { ReleaseNotesList } from "../components/versioningInfo/ReleaseNotesList";
import { ReleaseNotesEmptyState } from "../components/versioningInfo/ReleaseNotesEmptyState";
import { ReleaseNotesToolbar } from "../components/versioningInfo/ReleaseNotesToolbar";
import { filterReleaseNotes, sortReleaseNotes } from "../utils/releaseNotes";
import type { CardSortBy, SortDirection } from "../types/releaseNotes";

export const VersioningInfoContainer = () => {
  const { releaseNotes, loadReleaseNotes } = useReleaseNotes();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState<CardSortBy>("releaseDate");
  const [sortDirection, setSortDirection] = useState<SortDirection>("desc");

  useEffect(() => {
    loadReleaseNotes();
  }, []);

  const filteredReleaseNotes = useMemo(() => {
    return sortReleaseNotes(
      filterReleaseNotes(releaseNotes, searchTerm),
      sortBy,
      sortDirection,
    );
  }, [releaseNotes, searchTerm, sortBy, sortDirection]);

  const hasReleaseNotes = releaseNotes.length > 0;

  return (
    <div className="flex h-full min-h-0 flex-col bg-slate-50/50">
      <ReleaseNotesToolbar
        filtered={filteredReleaseNotes.length}
        total={releaseNotes.length}
        searchTerm={searchTerm}
        sortBy={sortBy}
        sortDirection={sortDirection}
        onSearchChange={setSearchTerm}
        onSortChange={setSortBy}
        onDirectionChange={setSortDirection}
      />

      <div className="min-h-0 flex-1 overflow-y-auto p-4">
        {filteredReleaseNotes.length === 0 ? (
          <ReleaseNotesEmptyState hasData={hasReleaseNotes} />
        ) : (
          <ReleaseNotesList releaseNotes={filteredReleaseNotes} />
        )}
      </div>
    </div>
  );
};
